import { render, staticRenderFns } from "./UnsupportedDevice.vue?vue&type=template&id=18ace00a&"
import script from "./UnsupportedDevice.vue?vue&type=script&lang=js&"
export * from "./UnsupportedDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports